// Minimal India geographic lookup — enough to auto-scope from GA4 realtime
// city/country dimensions. Coordinates are [lng, lat].

// State centroid + a display scale hint for zoom-to-state
export const INDIA_STATES = {
  "Karnataka":       { center: [76.5,  15.0], scale: 3400 },
  "Maharashtra":     { center: [75.5,  19.0], scale: 2800 },
  "Tamil Nadu":      { center: [78.5,  11.0], scale: 3200 },
  "Kerala":          { center: [76.4,  10.5], scale: 3800 },
  "Telangana":       { center: [79.2,  18.0], scale: 3400 },
  "Andhra Pradesh":  { center: [80.3,  15.9], scale: 2800 },
  "West Bengal":     { center: [87.9,  23.5], scale: 3200 },
  "Delhi":           { center: [77.2,  28.6], scale: 6500 },
  "Haryana":         { center: [76.3,  29.0], scale: 3800 },
  "Uttar Pradesh":   { center: [80.9,  26.8], scale: 2400 },
  "Madhya Pradesh":  { center: [78.6,  23.5], scale: 2400 },
  "Gujarat":         { center: [71.7,  22.6], scale: 2600 },
  "Rajasthan":       { center: [74.2,  26.9], scale: 2200 },
  "Punjab":          { center: [75.3,  30.9], scale: 4000 },
  "Bihar":           { center: [85.3,  25.4], scale: 3200 },
  "Odisha":          { center: [84.5,  20.3], scale: 3000 },
  "Assam":           { center: [92.9,  26.2], scale: 3200 },
  "Goa":             { center: [74.0,  15.4], scale: 6000 },
  "Jharkhand":       { center: [85.5,  23.6], scale: 3400 },
  "Chhattisgarh":    { center: [82.0,  21.2], scale: 2800 },
  "Uttarakhand":     { center: [79.0,  30.0], scale: 3800 },
  "Himachal Pradesh":{ center: [77.2,  31.9], scale: 3600 },
  "Jammu and Kashmir":{ center: [76.5, 33.5], scale: 3000 },
  "Chandigarh":      { center: [76.8,  30.7], scale: 8000 },
  "Puducherry":      { center: [79.8,  11.9], scale: 8000 },
};

// City name (normalised) → { state, coords[lng,lat] }
export const INDIA_CITIES = {
  // Karnataka
  "bangalore":   { state: "Karnataka", coords: [77.5946, 12.9716] },
  "bengaluru":   { state: "Karnataka", coords: [77.5946, 12.9716] },
  "mysore":      { state: "Karnataka", coords: [76.6394, 12.2958] },
  "mysuru":      { state: "Karnataka", coords: [76.6394, 12.2958] },
  "mangalore":   { state: "Karnataka", coords: [74.8560, 12.9141] },
  "mangaluru":   { state: "Karnataka", coords: [74.8560, 12.9141] },
  "hubli":       { state: "Karnataka", coords: [75.1240, 15.3647] },
  "hubballi":    { state: "Karnataka", coords: [75.1240, 15.3647] },
  "belgaum":     { state: "Karnataka", coords: [74.4977, 15.8497] },
  "belagavi":    { state: "Karnataka", coords: [74.4977, 15.8497] },
  "dharwad":     { state: "Karnataka", coords: [75.0078, 15.4589] },
  "udupi":       { state: "Karnataka", coords: [74.7421, 13.3409] },
  "shimoga":     { state: "Karnataka", coords: [75.5681, 13.9299] },
  "shivamogga":  { state: "Karnataka", coords: [75.5681, 13.9299] },
  "davangere":   { state: "Karnataka", coords: [75.9218, 14.4644] },
  "tumkur":      { state: "Karnataka", coords: [77.1173, 13.3379] },
  "tumakuru":    { state: "Karnataka", coords: [77.1173, 13.3379] },
  "bellary":     { state: "Karnataka", coords: [76.9214, 15.1394] },
  "gulbarga":    { state: "Karnataka", coords: [76.8343, 17.3297] },
  "kalaburagi":  { state: "Karnataka", coords: [76.8343, 17.3297] },
  "hassan":      { state: "Karnataka", coords: [76.0993, 13.0072] },
  "chikmagalur": { state: "Karnataka", coords: [75.7726, 13.3161] },

  // Maharashtra
  "mumbai":      { state: "Maharashtra", coords: [72.8777, 19.0760] },
  "pune":        { state: "Maharashtra", coords: [73.8567, 18.5204] },
  "nagpur":      { state: "Maharashtra", coords: [79.0882, 21.1458] },
  "nashik":      { state: "Maharashtra", coords: [73.7898, 19.9975] },
  "aurangabad":  { state: "Maharashtra", coords: [75.3433, 19.8762] },
  "thane":       { state: "Maharashtra", coords: [72.9781, 19.2183] },
  "kolhapur":    { state: "Maharashtra", coords: [74.2433, 16.7050] },

  // Delhi / NCR
  "new delhi":   { state: "Delhi", coords: [77.2090, 28.6139] },
  "delhi":       { state: "Delhi", coords: [77.2090, 28.6139] },
  "gurgaon":     { state: "Haryana", coords: [77.0266, 28.4595] },
  "gurugram":    { state: "Haryana", coords: [77.0266, 28.4595] },
  "noida":       { state: "Uttar Pradesh", coords: [77.3910, 28.5355] },
  "faridabad":   { state: "Haryana", coords: [77.3178, 28.4089] },

  // Tamil Nadu
  "chennai":       { state: "Tamil Nadu", coords: [80.2707, 13.0827] },
  "coimbatore":    { state: "Tamil Nadu", coords: [76.9558, 11.0168] },
  "madurai":       { state: "Tamil Nadu", coords: [78.1198, 9.9252] },
  "tiruchirappalli":{ state: "Tamil Nadu", coords: [78.7047, 10.7905] },
  "trichy":        { state: "Tamil Nadu", coords: [78.7047, 10.7905] },
  "salem":         { state: "Tamil Nadu", coords: [78.1460, 11.6643] },

  // Kerala
  "kochi":              { state: "Kerala", coords: [76.2673, 9.9312] },
  "cochin":             { state: "Kerala", coords: [76.2673, 9.9312] },
  "thiruvananthapuram": { state: "Kerala", coords: [76.9366, 8.5241] },
  "trivandrum":         { state: "Kerala", coords: [76.9366, 8.5241] },
  "kozhikode":          { state: "Kerala", coords: [75.7804, 11.2588] },
  "calicut":            { state: "Kerala", coords: [75.7804, 11.2588] },
  "thrissur":           { state: "Kerala", coords: [76.2144, 10.5276] },

  // Telangana
  "hyderabad":  { state: "Telangana", coords: [78.4867, 17.3850] },
  "warangal":   { state: "Telangana", coords: [79.5941, 17.9689] },

  // Andhra Pradesh
  "visakhapatnam":{ state: "Andhra Pradesh", coords: [83.2185, 17.6868] },
  "vizag":        { state: "Andhra Pradesh", coords: [83.2185, 17.6868] },
  "vijayawada":   { state: "Andhra Pradesh", coords: [80.6480, 16.5062] },
  "guntur":       { state: "Andhra Pradesh", coords: [80.4365, 16.3067] },

  // West Bengal
  "kolkata": { state: "West Bengal", coords: [88.3639, 22.5726] },
  "howrah":  { state: "West Bengal", coords: [88.3103, 22.5958] },

  // Gujarat
  "ahmedabad": { state: "Gujarat", coords: [72.5714, 23.0225] },
  "surat":     { state: "Gujarat", coords: [72.8311, 21.1702] },
  "vadodara":  { state: "Gujarat", coords: [73.1812, 22.3072] },
  "rajkot":    { state: "Gujarat", coords: [70.8022, 22.3039] },

  // Rajasthan
  "jaipur":  { state: "Rajasthan", coords: [75.7873, 26.9124] },
  "jodhpur": { state: "Rajasthan", coords: [73.0243, 26.2389] },
  "udaipur": { state: "Rajasthan", coords: [73.7125, 24.5854] },

  // UP
  "lucknow":   { state: "Uttar Pradesh", coords: [80.9462, 26.8467] },
  "kanpur":    { state: "Uttar Pradesh", coords: [80.3319, 26.4499] },
  "varanasi":  { state: "Uttar Pradesh", coords: [82.9739, 25.3176] },
  "agra":      { state: "Uttar Pradesh", coords: [78.0081, 27.1767] },
  "prayagraj": { state: "Uttar Pradesh", coords: [81.8463, 25.4358] },
  "allahabad": { state: "Uttar Pradesh", coords: [81.8463, 25.4358] },

  // MP
  "bhopal":  { state: "Madhya Pradesh", coords: [77.4126, 23.2599] },
  "indore":  { state: "Madhya Pradesh", coords: [75.8577, 22.7196] },

  // Punjab / Chandigarh
  "ludhiana":   { state: "Punjab", coords: [75.8573, 30.9010] },
  "amritsar":   { state: "Punjab", coords: [74.8723, 31.6340] },
  "chandigarh": { state: "Chandigarh", coords: [76.7794, 30.7333] },

  // Bihar
  "patna":  { state: "Bihar", coords: [85.1376, 25.5941] },

  // Odisha
  "bhubaneswar": { state: "Odisha", coords: [85.8245, 20.2961] },

  // Assam
  "guwahati": { state: "Assam", coords: [91.7362, 26.1445] },

  // Goa
  "panaji":         { state: "Goa", coords: [73.8278, 15.4909] },
  "vasco da gama":  { state: "Goa", coords: [73.8157, 15.3960] },

  // Uttarakhand / HP
  "dehradun": { state: "Uttarakhand", coords: [78.0322, 30.3165] },
  "shimla":   { state: "Himachal Pradesh", coords: [77.1734, 31.1048] },

  // Puducherry
  "puducherry": { state: "Puducherry", coords: [79.8083, 11.9139] },
  "pondicherry":{ state: "Puducherry", coords: [79.8083, 11.9139] },
};

export const cityLookup = (name) => {
  if (!name) return null;
  return INDIA_CITIES[name.trim().toLowerCase()] || null;
};
